<app-form-userbsk
    [requestList]="requestList"
    [basketList]="basketList"
    [request]="selectedRequest"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)">
</app-form-userbsk>
